import { render } from "./ContadorAguaPageV3.vue?vue&type=template&id=d3057ce2&scoped=true"
import script from "./ContadorAguaPageV3.vue?vue&type=script&lang=js"
export * from "./ContadorAguaPageV3.vue?vue&type=script&lang=js"

import "./ContadorAguaPageV3.vue?vue&type=style&index=0&id=d3057ce2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3057ce2"]])

export default __exports__